module.exports = __webpack_public_path__ + "img/upload.31d42e57.png";